import { ObjectType } from '../enums';
import { MultiContactObjectValue } from '../interfaces';
import { isGenericObjectValue } from './IsGenericObjectValue';

export const isMultiContactObjectValue = (objectValue: any): objectValue is MultiContactObjectValue =>  {
    return isGenericObjectValue(objectValue)
        && objectValue.objectType === ObjectType.MULTI_CONTACT;
};
